module.exports = __webpack_public_path__ + "media/images/gallery/gal_tab_off-1d951a0dfff2e1eacc207ba59eb98401.jpg";